import React, { useState } from "react";
import { Modal, Form, Input, Button } from "antd";
// import { useCreateItem } from "../show/forms/junction";--> use this

//only for passing import error
import { useCreateItem } from "../_actions/mutations/items";

function AddCategoryModal({ trigger }) {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const mutationCreate = useCreateItem(
        "qdb_post_types",
        () => {},
        (res) => {
            setIsModalOpen(false);
        },
        () => {},
        () => {}
    );

    const showModal = () => setIsModalOpen(true);
    const handleCancel = () => setIsModalOpen(false);

    const onFinish = (values) => {
        console.log("Form values:", values);
        // TODO: Implement category addition logic (e.g., API call)
        // setIsModalOpen(false);
        mutationCreate.mutate({
            name: values.name,
            display_name: values.name,
            description: values.description,
        });
    };

    return (
        <>
            <span onClick={showModal} style={{ cursor: "pointer" }}>
                {trigger}
            </span>
            <Modal
                title="Add Category"
                open={isModalOpen}
                onCancel={handleCancel}
                footer={null}
            >
                <Form name="addCategory" onFinish={onFinish} layout="vertical">
                    <Form.Item
                        label="Name"
                        name="name"
                        rules={[
                            {
                                required: true,
                                message: "Please input the category name!",
                            },
                        ]}
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item label="Description" name="description">
                        <Input.TextArea />
                    </Form.Item>
                    <Form.Item>
                        <Button
                            type="primary"
                            htmlType="submit"
                            loading={mutationCreate.isLoading}
                        >
                            Add
                        </Button>
                    </Form.Item>
                </Form>
            </Modal>
        </>
    );
}

export default AddCategoryModal;
